import AnalyticsProvider, { useAnalytics, withAnalytics } from './AnalyticsProvider';
export { AnalyticsProvider as UniversalAnalyticsProvider } from '@skooldio/analytics-provider';
export { useAnalytics, withAnalytics };
export default AnalyticsProvider;
